import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Card, Button, Row, Col } from "reactstrap";
import Loader from "../../components/Common/Loader";
import {
  getGestionesContactoRead,
  getReportSupervisor,
} from "../../helpers/backend";
import { Link } from "react-router-dom/cjs/react-router-dom";
import ModalManagementDetails from "../Whatsapp/components/ModalManagementDetails";
import Table from "../../components/Common/Table";
import { useSelector } from "react-redux";
import ButtonVolver from "../../components/ButtonVolver";

const ReportSupervisor = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [enEspera, setEnEspera] = useState({});
  const [gestionesData, setGestionesData] = useState([]);
  const [detallesModal, setDetallesModal] = useState(false);
  const [GestionDetallada, setGestionDetallada] = useState(false);

  const getReportData = async () => {
    setLoading(true);
    const response = await getReportSupervisor();
    setData(response.data.agentes);
    setEnEspera(response.data.en_espera);
    setLoading(false);
    console.log(response);
  };

  const theme = useSelector((state) => state.theme.theme) || "light";

  useEffect(() => {
    getReportData();
  }, []);

  const handleGestionesClick = (gestiones) => {
    setGestionesData(gestiones);
  };

  const handleCloseDetails = () => {
    setGestionesData([]); // Limpiamos los datos de gestiones para ocultar la tabla
  };

  const handleDetalle = async (id) => {
    const resp = await getGestionesContactoRead(id);
    setGestionDetallada(resp.data);
    setDetallesModal(true);
  };

  const attendedColumns = [
    { key: "full_name", label: "Agente", filterable: true },
    { key: "statusBadge", label: "Estado", filterable: true },
    { key: "enGestion", label: "En Gestión", filterable: false },
    { key: "finalHoy", label: "Finalizadas Hoy", filterable: false },
    { key: "last_login", label: "Última Conexión", filterable: true },
    { key: "sessionLink", label: "", filterable: false },
  ];
  const attendedData = data.map((a) => ({
    full_name: a.full_name,
    statusBadge:
      a.status === "CONECTADO" ? (
        <span className="badge bg-success">Conectado</span>
      ) : (
        <span className="badge bg-danger">Desconectado</span>
      ),
    enGestion: (
      <Link to="#" onClick={() => handleGestionesClick(a.gestiones_en_gestion)}>
        {a.gestiones_en_gestion_count}
      </Link>
    ),
    finalHoy: (
      <Link
        to="#"
        onClick={() => handleGestionesClick(a.gestiones_finalizadas_hoy)}
      >
        {a.gestiones_finalizadas_hoy_count}
      </Link>
    ),
    last_login: a.last_login,
    sessionLink: (
      <Link to={`/sessionList/${a.contact_id}`}>
        <span className="fas fa-history fa-lg" />
      </Link>
    ),
  }));

  // 2) Tabla de “Conversaciones en Espera”
  const waitingColumns = [
    { key: "campaign", label: "Campaña",   filterable: true },
    { key: "count",    label: "En Espera", filterable: false },
  ];
  const waitingData = Object.entries(enEspera).map(([campaign, det]) => ({
    campaign,
    count: (
      <Link to="#" onClick={() => handleGestionesClick(det.gestiones)}>
        {det.count}
      </Link>
    )
  }));

  // 3) Tabla de “Detalles de Gestiones”
  const detailColumns = [
    { key: "contacto",      label: "Contacto",           filterable: true },
    { key: "estado",        label: "Estado",             filterable: true },
    { key: "created_date",  label: "Fecha",              filterable: true },
    { key: "type",          label: "Canal de Comunicación", filterable: true },
    { key: "eye",           label: "Acción",             filterable: false },
  ];
  const detailData = gestionesData.map(g => ({
    contacto:     g.contacto,
    estado:       g.estado,
    created_date: g.created_date,
    type:         g.type,
    eye: (
      <Link to="#" onClick={() => handleDetalle(g.id)}>
        <span className="fas fa-eye fa-lg" />
      </Link>
    )
  }));

  if (loading) return <Loader />;

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> Cuidad Limpia | Reporte de Supervisión </title>
        </MetaTags>
        <Container fluid>
          <Col className="d-flex gap-3 mb-4 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Reporte de supervición
            </span>
          </Col>
          {loading ? (
            <Loader />
          ) : (
            <Card className="p-2">
              {detallesModal ? (
                <ModalManagementDetails
                  isOpen={detallesModal}
                  onCloseClick={() => setDetallesModal(false)}
                  GestionDetallada={GestionDetallada}
                ></ModalManagementDetails>
              ) : null}
              <Row>
                <Col>
                  <h5 className="p-3">Conversaciones Atendidas</h5>
                  <Table
                    data={attendedData}
                    columns={attendedColumns}
                    theme={theme}
                  />
                </Col>
                <Col>
                  <h5 className="p-3">Conversaciones en Espera</h5>
                  <Table
                    data={waitingData}
                    columns={waitingColumns}
                    theme={theme}
                  />
                </Col>
              </Row>
              {gestionesData.length > 0 && (
                <Row className="d-flex justify-content-center ">
                  <Col className="col-lg-10 ">
                    <h5 className="p-3">
                      Detalles de Gestiones
                      <Button
                        color="danger"
                        className="ms-2 btn-sm"
                        onClick={handleCloseDetails}
                      >
                        Cerrar
                      </Button>
                    </h5>
                    <div
                      className="custom-scroll "
                      style={{ maxHeight: "400px", overflowY: "auto" }}
                    >
                      <Table
                        data={detailData}
                        columns={detailColumns}
                        theme={theme}
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReportSupervisor;
